module.exports = __webpack_public_path__ + "img/BTG.bfa7cb65.png";